export default {
  // vehivle count
  findJarmuSzuksegletCount: (logisticData) => {
    const totalVehicles =
      logisticData?.pkw * 1 +
      logisticData?.pkw_extra * 1 +
      logisticData?.transport_17 * 1 +
      logisticData?.transport_17_extra * 1 +
      logisticData?.transport_27 * 1 +
      logisticData?.transport_27_extra * 1 +
      logisticData?.transport_47 * 1 +
      logisticData?.transport_47_extra * 1 +
      logisticData?.transport_95 * 1 +
      logisticData?.transport_95_extra * 1 +
      logisticData?.transport_140 * 1 +
      logisticData?.transport_140_extra * 1;

    return totalVehicles;
  },

  findTavolsag: (tourPlan) => {
    let totalDistance = 0;
    tourPlan.map((tour) => {
      totalDistance += parseDistance(tour?.inter_distance);
    });
    return parseFloat(totalDistance / 1000).toFixed(2);
  },

  findTerfogat: (items) => {
    let totalVolume = 0;
    items.map((item) => {
      totalVolume += item?.capacity;
    });
    return totalVolume;
  },

  findTotalMunkaeroSzukseglet: (logisticData) => {
    const totalVehicles =
      logisticData[0]?.pkw * 1 +
      logisticData[0]?.pkw_extra * 1 +
      logisticData[0]?.transport_17 * 1 +
      logisticData[0]?.transport_27 * 1 +
      logisticData[0]?.transport_47 * 1 +
      logisticData[0]?.transport_95 * 1 +
      logisticData[0]?.transport_140 * 1 +
      logisticData[0]?.pkw_extra * 1 +
      logisticData[0]?.hanger_extra * 1 +
      logisticData[0]?.transport_17_extra * 1 +
      logisticData[0]?.transport_27_extra * 1 +
      logisticData[0]?.transport_47_extra * 1 +
      logisticData[0]?.transport_95_extra * 1 +
      logisticData[0]?.transport_140_extra;

    const totalMunkaero =
      totalVehicles +
      logisticData[0]?.villanyszerelo +
      logisticData[0]?.kuchenmonteur +
      logisticData[0]?.munkaero;
    return totalMunkaero;
  },

  findSzemelyzetiArNew: (proposalTourPlan, logisticData) => {
    // total distance
    let totalDistance = 0;
    proposalTourPlan.map((tour) => {
      totalDistance += parseDistance(tour?.inter_distance);
    });

    const totalDistanceInKM = totalDistance / 1000;
    console.log(totalDistanceInKM);

    const totalVehicles =
      logisticData[0]?.pkw * 1 +
      logisticData[0]?.pkw_extra * 1 +
      logisticData[0]?.transport_17 * 1 +
      logisticData[0]?.transport_27 * 1 +
      logisticData[0]?.transport_47 * 1 +
      logisticData[0]?.transport_95 * 1 +
      logisticData[0]?.transport_140 * 1 +
      logisticData[0]?.pkw_extra * 1 +
      logisticData[0]?.hanger_extra * 1 +
      logisticData[0]?.transport_17_extra * 1 +
      logisticData[0]?.transport_27_extra * 1 +
      logisticData[0]?.transport_47_extra * 1 +
      logisticData[0]?.transport_95_extra * 1 +
      logisticData[0]?.transport_140_extra;

    const noOfDrivers = totalVehicles;
    const noOfLabours = logisticData[0]?.munkaero;

    let totalAmount = 0;
    if (totalDistanceInKM < 100) {
      if (totalVehicles < 2) {
        if (totalDistanceInKM <= 30) {
          totalAmount = (noOfLabours + noOfDrivers) * 79;
        } else if (totalDistanceInKM > 30) {
          totalAmount = (noOfLabours + noOfDrivers) * 129;
        }
      } else {
        if (totalDistanceInKM <= 30) {
          totalAmount = (noOfLabours + noOfDrivers) * 179;
        } else if (totalDistanceInKM > 30) {
          totalAmount = (noOfLabours + noOfDrivers) * 229;
        }
      }
      console.log(totalAmount.toFixed(2));
      return totalAmount.toFixed(2);
    } else {
      const remainingDistanceInKM = totalDistanceInKM * 1 - 100;
      if (totalVehicles < 2) {
        totalAmount = (noOfLabours * 1 + noOfDrivers * 1) * 129;
        if (noOfLabours > 2) {
          totalAmount +=
            remainingDistanceInKM * 1 * 0.98 +
            remainingDistanceInKM * 1 * 2 * 1.84 +
            remainingDistanceInKM * 1 * (noOfLabours * 1 - 2) * 0.43;
        } else if (noOfLabours == 2) {
          totalAmount +=
            remainingDistanceInKM * 1 * 0.98 +
            remainingDistanceInKM * 1 * 2 * 1.84;
        } else if (noOfLabours == 1) {
          totalAmount +=
            remainingDistanceInKM * 1 * 0.98 + remainingDistanceInKM * 1 * 1.41;
        } else {
          totalAmount += remainingDistanceInKM * 1 * 0.98;
        }
      } else {
        totalAmount = (noOfLabours * 1 + noOfDrivers * 1) * 229;
        if (noOfLabours > 2) {
          totalAmount +=
            remainingDistanceInKM * 1 * totalVehicles * 1 * 1.53 +
            remainingDistanceInKM * 1 * 2 * 2.39 +
            remainingDistanceInKM * 1 * (noOfLabours * 1 - 2) * 0.55;
        } else if (noOfLabours == 2) {
          totalAmount +=
            remainingDistanceInKM * 1 * totalVehicles * 1 * 1.53 +
            remainingDistanceInKM * 1 * 2 * 2.39;
        } else if (noOfLabours == 1) {
          totalAmount +=
            remainingDistanceInKM * 1 * totalVehicles * 1 * 1.53 +
            remainingDistanceInKM * 1 * 1.96;
        } else {
          totalAmount += remainingDistanceInKM * 1 * totalVehicles * 1 * 1.53;
        }
      }
      console.log(totalAmount.toFixed(2));
      return totalAmount.toFixed(2);
    }
  },
  findUtvonal: (proposalTourPlan, transactionFees, fees, items) => {
    if (
      proposalTourPlan != undefined &&
      transactionFees != undefined &&
      fees != undefined &&
      items != undefined
    ) {
      //totalVolument
      let totalVolume = 0;
      items.map((item) => {
        totalVolume += item?.capacity;
      });

      // total distance
      let totalDistance = 0;
      proposalTourPlan.map((tour) => {
        totalDistance += parseDistance(tour?.inter_distance);
      });
      // transport fees
      const transportFees = transactionFees[0];

      totalDistance = parseFloat(totalDistance / 1000).toFixed(2);
      // transport fees
      let tranportFee = 0;

      if (transportFees) {
        if (totalDistance < 150) {
          let remaning = totalDistance - 50;
          if (remaning < 0) {
            remaning = 0;
          }
          if (totalVolume < 17) {
            tranportFee =
              tranportFee +
              remaning * transportFees?.transport_17m3_belade_150 * 1;
            let remainDis =
              totalDistance - proposalTourPlan[0]?.inter_distance * 1;
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_17m3_presis_pro_150 * 1;
          } else if (totalVolume < 27) {
            tranportFee =
              tranportFee +
              remaning * transportFees?.transport_27m3_belade_150 * 1;
            let remainDis =
              totalDistance - proposalTourPlan[0]?.inter_distance * 1;
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_27m3_presis_pro_150 * 1;
          } else if (totalVolume < 47) {
            tranportFee =
              tranportFee +
              remaning * transportFees?.transport_47m3_belade_150 * 1;
            let remainDis =
              totalDistance - proposalTourPlan[0]?.inter_distance * 1;
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_47m3_presis_pro_150 * 1;
          } else if (totalVolume < 95) {
            tranportFee =
              tranportFee +
              remaning * transportFees?.transport_95m3_belade_150 * 1;
            let remainDis =
              totalDistance - proposalTourPlan[0]?.inter_distance * 1;
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_95m3_presis_pro_150 * 1;
          } else {
            tranportFee =
              tranportFee +
              remaning * transportFees?.transport_140m3_belade_150 * 1;
            let remainDis =
              totalDistance - proposalTourPlan[0]?.inter_distance * 1;
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_140m3_presis_pro_150 * 1;
          }
        } else {
          let remaning = totalDistance - 50;
          if (remaning < 0) {
            remaning = 0;
          }
          if (totalVolume < 17) {
            tranportFee =
              tranportFee +
              remaning * transportFees?.transport_17m3_belade_151 * 1;
            let remainDis =
              totalDistance -
              parseDistance(proposalTourPlan[0]?.inter_distance) * 1;
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_17m3_presis_pro_151 * 1;
          } else if (totalVolume < 27) {
            tranportFee =
              tranportFee +
              remaning * transportFees?.transport_27m3_belade_151 * 1;
            let remainDis =
              totalDistance -
              parseDistance(proposalTourPlan[0]?.inter_distance) * 1;
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_27m3_presis_pro_151 * 1;
          } else if (totalVolume < 47) {
            tranportFee =
              tranportFee + transportFees?.transport_47m3_belade_151 * 1;
            let remainDis =
              totalDistance -
              parseDistance(proposalTourPlan[0]?.inter_distance) * 1;
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_47m3_presis_pro_151 * 1;
          } else if (totalVolume < 95) {
            tranportFee =
              tranportFee + remaning * transportFees?.transport_95m3_blade_151;

            console.log(tranportFee, remaning, transportFees);
            let remainDis =
              totalDistance -
              (parseDistance(proposalTourPlan[0]?.inter_distance) / 1000) * 1;

            console.log(tranportFee);
            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_95m3_presis_pro_151;

            console.log(tranportFee);
          } else {
            tranportFee =
              tranportFee +
              remaning * transportFees?.transport_95m3_140_blade_151 * 1;
            let remainDis =
              totalDistance -
              parseDistance(proposalTourPlan[0]?.inter_distance) * 1;

            tranportFee =
              tranportFee +
              remainDis * transportFees?.transport_95m3_140_presis_pro_151 * 1;
          }
        }
      }

      return tranportFee;
    }
  },

  findTetalAr: (proposalItems, fee) => {
    let total = 0;
    proposalItems.forEach((item) => {
      total += item?.gegenstand * item?.volume * fee[0]?.beladen_euro_m3;
    });
    return total;
  },
  findStopAr: (proposalTourPlan, fees) => {
    let stopAr = 0;
    proposalTourPlan.map((tourLocation) => {
      stopAr +=
        tourLocation?.megallo != null
          ? parseInt(tourLocation?.megallo) * fees[0]?.be_und_entladestelle
          : 0 * fees[0]?.be_und_entladestelle;
    });
    return stopAr;
  },
  findNincsAr: (proposalTourPlan, fees) => {
    let stopAr = 0;
    proposalTourPlan.slice(1).map((tourLocation) => {
      stopAr +=
        tourLocation?.kozteruleti_ugyintezes == true
          ? 1 * fees[0]?.halteverbotszone
          : 0 * fees[0]?.halteverbotszone;
    });
    return stopAr;
  },
  findKuchenmonteurAr: (proposalLogistic, fees) => {
    return proposalLogistic[0]?.kuchenmonteur * fees[0]?.kuchenmonteur_euro_std;
  },
  fintAlaconyCost: (proposalTourPlan, proposalItems, fees) => {
    let extraFees = 0;
    proposalTourPlan.map((tourPlan) => {
      if (parseInt(tourPlan?.emelet) > 1) {
        // No extra fees
        // if (tourPlan?.lift == 1) {
        const capacity = calTotalCapacity(proposalItems, tourPlan?.id);
        extraFees += fees[0]?.zuschlag_geschoss * capacity;
        // }
      } else {
        extraFees += 0;
      }
    });
    if (extraFees == 0) {
      return 0;
    } else {
      return extraFees * 1;
    }
  },
  findtarolasiAr: (proposalItems, fees, proposalLogistic) => {
    let tarolasAr = 0;
    proposalItems.map((item) => {
      if (item?.einlagern_checked) {
        tarolasAr +=
          item?.gegenstand *
          parseFloat(item?.volume) *
          item?.einlagern_checked *
          fees[0]?.lagerentgelt_je *
          1;
      }
    });
    if (
      proposalLogistic[0]?.tarolasi_napok_szama -
        fees[0]?.tarolasi_napok_szama <=
      0
    ) {
      return parseFloat(0).toFixed(2);
    } else {
      var result =
        tarolasAr *
        fees[0]?.lagerentgelt_je *
        Math.ceil(
          (proposalLogistic[0]?.tarolasi_napok_szama -
            fees[0]?.tarolasi_napok_szama) /
            7
        );

      return result.toFixed(2);
    }
  },
  findProductCost: (proposalItems, fee) => {
    let bontasi_ar = 0;
    let telepitesi_ar = 0;
    let csomagolasi_ar = 0;
    let buborekfolio_ar = 0;
    let nehez_rakomany_ar = 0;
    let bolti_ar = 0;

    if (proposalItems != undefined && fee != undefined) {
      proposalItems.map((item) => {
        const gegenstand = item?.gegenstand ? item?.gegenstand : 0;
        const demontage = item?.demontage_checked ? 1 : 0;
        const montage = item?.montage_checked ? 1 : 0;
        const einpacken = item?.einpacken_checked ? 1 : 0;
        const luftpolsterfol = item?.luftpolsterfol_checked ? 1 : 0;
        const auspacken = item?.auspacken_checked ? 1 : 0;
        const entsorgen = item?.entsorgen_checked ? 1 : 0;
        const schwergut = item?.schwergut_checked ? 1 : 0;
        const einlagern = item?.einlagern_checked ? 1 : 0;

        if (demontage == 1) {
          bontasi_ar +=
            (item?.villanyszerelo == true
              ? gegenstand *
                demontage *
                item?.szetszerelesi_ido *
                fee[0]?.kuchenmonteur_euro_std
              : 0) +
            //
            (item?.konyhaszerelo == true
              ? gegenstand *
                demontage *
                item?.szetszerelesi_ido *
                fee[0]?.kuchenmonteur_euro_std
              : 0) +
            //
            gegenstand *
              demontage *
              item?.szetszerelesi_ido *
              fee[0]?.de_und_remontage_euro_std;
        }
        if (montage == 1) {
          telepitesi_ar +=
            (item?.villanyszerelo == true
              ? gegenstand *
                montage *
                item?.osszeszerelesi_ido *
                fee[0]?.kuchenmonteur_euro_std
              : 0) +
            //
            (item?.konyhaszerelo == true
              ? gegenstand *
                montage *
                item?.osszeszerelesi_ido *
                fee[0]?.kuchenmonteur_euro_std
              : 0) +
            //
            gegenstand *
              montage *
              item?.osszeszerelesi_ido *
              fee[0]?.de_und_remontage_euro_std;
        }
        if (einpacken == 1) {
          csomagolasi_ar +=
            item.csomagolasi_ido * fee[0]?.auspacken_euro_m3 * item.gegenstand;
        }
        if (luftpolsterfol == 1) {
          buborekfolio_ar +=
            gegenstand *
            luftpolsterfol *
            fee[0]?.auspacken_euro_m3 *
            parseFloat(item?.buborekcsomagolasi_ido);
        }
        if (schwergut == 1) {
          nehez_rakomany_ar +=
            schwergut * item?.gegenstand * fee[0]?.zuschlag_schwergut;
        }
        // if (einlagern == 1) {
        bolti_ar += gegenstand * item?.volume * 1 * fee[0]?.lagerentgelt_je * 1;
        // }
      });
      return {
        bontasi_ar,
        telepitesi_ar,
        csomagolasi_ar,
        buborekfolio_ar,
        nehez_rakomany_ar,
        bolti_ar,
      };
    } else {
      return {
        bontasi_ar,
        telepitesi_ar,
        csomagolasi_ar,
        buborekfolio_ar,
        nehez_rakomany_ar,
        bolti_ar,
      };
    }
  },
  findKoyhasAndVillanysZerelo: (proposalItems, fee, proposalLogistic) => {
    let KonyhaszereloAr = 0;
    let VillanyszereloAr = 0;
    let SzemelyzetiAr = 0;

    proposalItems.map((item, index) => {
      console.log(
        item?.szetszerelesi_ido,
        item?.gegenstand,
        item?.osszeszerelesi_ido
      );
      KonyhaszereloAr +=
        (item?.konyhaszerelo == true
          ? item?.gegenstand *
            1 *
            item?.szetszerelesi_ido *
            1 *
            fee[0]?.kuchenmonteur_euro_std *
            1
          : 0) +
        (item?.konyhaszerelo == true
          ? item?.gegenstand *
            1 *
            item?.osszeszerelesi_ido *
            1 *
            fee[0]?.kuchenmonteur_euro_std *
            1
          : 0);

      VillanyszereloAr +=
        (item?.villanyszerelo == true
          ? item?.gegenstand *
            item?.szetszerelesi_ido *
            fee[0]?.elektriker_euro_std
          : 0) +
        (item?.villanyszerelo == true
          ? item?.gegenstand *
            item?.osszeszerelesi_ido *
            fee[0]?.elektriker_euro_std
          : 0);

      SzemelyzetiAr +=
        (item?.villanyszerelo == false && item?.konyhaszerelo == false
          ? item?.gegenstand *
            item?.szetszerelesi_ido *
            fee[0]?.elektriker_euro_std
          : 0) +
        (item?.villanyszerelo == false && item?.konyhaszerelo == false
          ? item?.gegenstand *
            item?.osszeszerelesi_ido *
            fee[0]?.elektriker_euro_std
          : 0);
    });

    console.log(KonyhaszereloAr);
    KonyhaszereloAr = KonyhaszereloAr * proposalLogistic[0]?.kuchenmonteur;
    VillanyszereloAr = VillanyszereloAr * proposalLogistic[0]?.villanyszerelo;
    SzemelyzetiAr = SzemelyzetiAr * proposalLogistic[0]?.munkaero;

    return {
      VillanyszereloAr,
      KonyhaszereloAr,
      SzemelyzetiAr,
    };
  },
};

const parseDistance = (distanceString) => {
  if (distanceString == null) {
    return 0;
  } else {
    const parts = distanceString.split(" ");
    const value = parseFloat(parts[0].replace(/,/g, ""));
    const unit = parts[1];
    if (unit === "m") {
      return value;
    } else {
      return value * 1000; // Convert kilometers to meters
    }
  }
};
const calTotalCapacity = (items, givenLocationId) => {
  const totalCapacity = items
    .filter((item) => item.location_id === givenLocationId)
    .reduce((accumulator, item) => accumulator + item.capacity, 0);
  return totalCapacity;
};
